export default "https://cdn-static.gokick.com/assets/f3c431ab621bc71377aad81f5421d83f1421a0d2/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";